import React from "react";
import "../../Default.css";

function BS() {
  return (
    <>
      <div className="page-title">Regulamin zdobywania BSki</div>
      <div className="boxes-contener">
        <div className="copyright-tekst">„Z pośpiechem do Lizbony”</div>
        <div className="text">
          <div className="paragraf">
            Po raz kolejny młodzi całego świata, więc także harcerki i harcerze
            ZHR, zostali zaproszeni przez papieża na Światowe Dni Młodzieży do
            Lizbony. Papież Franciszek uczynił to na zakończenie ŚDM w Panamie w
            2019 roku, gdzie na zaproszenie organizatorów kilkusetosobowa
            delegacja ZHR pełniła służbę, głównie jako zaplecze medyczne.
          </div>
          <div className="paragraf">
            W Portugalii również chcemy pełnić Białą Służbę wobec pielgrzymów i
            spotkać się z młodzieżą całego świata, by wymienić się wzajemnie
            doświadczeniem wiary w Jezusa Chrystusa, narodzonego z Maryi
            Dziewicy. Wiary, która góry przenosi i jest siłą każdego dnia dającą
            sens i kierunek naszemu życiu.
          </div>
          <div className="paragraf">
            Sprawność{" "}
            <b>
              <i>Biała Służba</i>
            </b>
            , która jest z nami od drugiej pielgrzymki Jana Pawła II do Polski w
            1983 roku, dotyczy także Światowych Dni Młodzieży. Zdobywana była w
            1991 roku w Częstochowie. Zatem jest to kolejna edycja dla gotowych
            do służby harcerek i harcerzy. Sprawność dla Ciebie!
          </div>
          <div className="text-box-accent">Oto jej wymagania:</div>
        </div>
        <div className="text-box-align">
          <div className="list-header">
            Zachęta (nieobowiązkowa w ramach zaliczenia sprawności)
          </div>
          <ol type="a">
            <li>Obserwuję komunikaty i informacje komendy Białej Służby.</li>
            <li>Poznałam/-em hasło i logo ŚDM.</li>
            <li>
              Jestem na bieżąco z aktualnościami Krajowego Biura Organizacyjnego
              ŚDM https://sdmpolska.pl
            </li>
            <li>
              Przed wyjazdem wyspowiadałam/-em się, by w pełni przygotować się
              do pielgrzymki i BS do Portugalii.
            </li>
            <li>
              Zapoznałam/-em się z informacjami na temat diecezji, w której
              spędzę czas przed spotkaniem w Lizbonie.
            </li>
          </ol>
        </div>
        <div className="text-box-align">
          <div className="text-box-accent">
            Wymagania (aby zaliczyć sprawność, wystarczy wypełnić jedno zadanie
            z każdego etapu)
          </div>
        </div>
        <div className="text-box-align">
          <div className="text-box-subheader">Etap 1. Przygotowanie</div>
          <div className="paragraf">
            Spośród 12 świętych przedstawionych przez organizatorów
            (https://sdmpolska.pl/patroni), wybrałam/em patrona na swoją
            pielgrzymkę. Są to święci związani z Portugalią i młodymi, a każdy z
            nich ma swój symbol. Umieściłam/-em go na jednym ze swoich
            komunikatorów zwytłumaczeniem, dlaczego wybrałam/-em właśnie tę
            osobę. W swojej modlitwie korzystam ze wstawiennictwa wybranego
            świętego.
          </div>
        </div>
        <div className="text-box-align">
          <div className="text-box-subheader">
            Etap 2. Przejazd autokarem z Polski do Portugalii
          </div>
          <ol type="a">
            <li>
              Wzięłam/-ąłem na siebie zaproponowaną funkcję w ramach
              przygotowania lub samego przejazdu (komendant, kwatermistrz,
              oboźny, kucharz, duszpasterz, przewodnik, gitarzysta, śpiewak,
              pomoc bagażowa, specjalista od mediów społecznościowych etc.).
              Wykonałem ją rzetelnie i skutecznie.
            </li>
            <li>
              Przygotowałam/-em zadany opis fragmentu trasy i
              zaprezentowałam/-em go w autokarze.
            </li>
            <li>
              Przygotowałam/-em i poprowadziłam/-em jedną z modlitw w czasie
              drogi (może być w małym zespole).
            </li>
          </ol>
        </div>
        <div className="text-box-align">
          <div className="text-box-subheader">Etap 3. Dni w Diecezjach</div>
          <ol type="a">
            <li>
              Przygotowałam/-em i/lub poprowadziłam/-em część programu, wraz z
              lokalną łodzieżą: religijną, muzyczną, geograficzną, przyrodniczą
              etc.
            </li>
            <li>
              Przyjęłam/em jedną z funkcji w zespole koordynującym nasze
              działania w goszczącej nas diecezji.
            </li>
            <li>
              Czynnie działałam/-em na rzecz integracji rodziny czy grupy
              gospodarzy, u których mieszkałam/-em w ramach programu.
            </li>
          </ol>
        </div>
        <div className="text-box-align">
          <div className="text-box-subheader">
            Etap 4. Spotkanie centralne w Lizbonie
          </div>
          <ol type="a">
            <li>
              Czynnie uczestniczyłam/-em w codziennych wydarzeniach
              przygotowanych przez organizatorów.
            </li>
            <li>
              Włączyłam/-em się w wolontariat ŚDM i służyłam/-em w ten sposób
              braciom i siostrom z całego świata.
            </li>
          </ol>
        </div>
        <div className="text-box-align">
          <div className="text-box-subheader">
            Etap 5. Przejazd autokarem z Portugalii do Polski
          </div>
          <ol type="a">
            <li>
              Podzieliłam/-em się w autokarze refleksją/świadectwem z tego, co i
              dlaczego mnie duchowo poruszyło i zmieniło podczas BS 2023.
            </li>
            <li>
              Pomogłam/-em w organizacji lub modlitwie w drodze powrotnej.
            </li>
          </ol>
        </div>
        <div className="text-box-align">
          <div className="text-box-subheader">
            Etap 6. Po powrocie (zadanie honorowe, nieobowiązkowe do zaliczenia
            sprawności)
          </div>
          <div className="paragraf">
            Podzieliłam/-em się wrażeniami z BS w swoim zastępie, gromadzie,
            drużynie, hufcu, etc. zależnie od pełnionej służby.
          </div>
        </div>
        <div className="text-box-align">
          <div className="text-box-accent">
            Wykonanie zadań weryfikowane jest na podstawie formularza.
            Przyznanie sprawności ogłaszane jest w rozkazie Komendanta BS 2023.
          </div>

          <a href="https://docs.google.com/forms/d/e/1FAIpQLSfIO7JQJI_uoJ2y-jh1Jv_sbSiXWpnEOKl0plou7An693xi7w/viewform">
            <div className="text-box-header">formularz</div>
            <p>
              uzupełnienie formularza wymagane jest w celu uzyskania sprawności
            </p>
          </a>
        </div>
      </div>
    </>
  );
}

export default BS;
